import { useEffect, useState } from "react";
import { MarkdownPreview } from "../../../components/MarkdownPreview";

export default function ReveshareResources() {
  const [markdownContent, setMarkdownContent] = useState("");

  useEffect(() => {
    // Load the markdown file
    fetch("/REVESHARE BRAND RESOURCES.md")
      .then((response) => response.text())
      .then((text) => setMarkdownContent(text))
      .catch((error) => console.error("Error loading markdown:", error));
  }, []);

  if (!markdownContent) {
    return (
      <div
        className="bg-background text-foreground"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p style={{ fontFamily: '"Calibri", "Arial", sans-serif' }}>
          Loading...
        </p>
      </div>
    );
  }

  return (
    <div
    className="no-box-shadow bg-background md:py-[40px] md:px-[20px]"
      style={{
        minHeight: "100vh",
      }}
    >
      <div
        className="no-box-shadow bg-card py-4 px-4 md:py-[60px] md:px-[72px]"// Google Docs padding"
        style={{
          maxWidth: "916px", // Standard document width (8.5 inches at 96 DPI)
          margin: "0 auto",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        }}
      >
        <MarkdownPreview content={markdownContent} />
      </div>
    </div>
  );
}
